module.exports = __webpack_public_path__ + "img/ELW_1.54d8318f.svg";